"use client";

import { useCallback, useMemo } from "react";
import { parseAsString } from "nuqs";
import { ArbiAcademyModal } from "@/components/ui/arbi-academy-modal";
import { useQuerySearchParams } from "@/hooks/use-query-search-params";
import { JOBS_ACADEMY_CONTENT } from "../lib/jobs";

const JOBS_ACADEMY_QUERY = {
  field: "jobs_academy",
  parser: parseAsString.withDefault(""),
} as const;

export function useOpenJobsAcademy() {
  const [, setParam] = useQuerySearchParams(JOBS_ACADEMY_QUERY);
  return useCallback(() => {
    setParam("true", { history: "replace", scroll: false });
  }, [setParam]);
}

export function JobsAcademyModal() {
  const [raw, setParam] = useQuerySearchParams(JOBS_ACADEMY_QUERY);
  const open = useMemo(() => raw === "true", [raw]);

  const onClose = useCallback(() => {
    setParam(null, { history: "replace", scroll: false });
  }, [setParam]);

  return (
    <ArbiAcademyModal
      open={open}
      onClose={onClose}
      content={JOBS_ACADEMY_CONTENT}
    />
  );
}
